// import { takeLatest, put, all, select } from 'redux-saga/effects';
// import {
//   LOAD_COMMISSION_SHOW,
//   setCommissionShow,
//   CHANGE_PAGE,
//   setCommissionDirectMerchants,
//   setCommissionPartners,
//   UPDATE_LOAD_COMMISSION_SHOW,
//   commissionDueShowFailed,
//   commissionDueUpdateShowFailed,
//   SET_PER_PAGE_FILTER,
//   setPaginatorTotal,
//   ORDER_BY_DIRECT_MERCHANTS_PROCESSING_VOLUME,
//   ORDER_BY_DIRECT_MERCHANTS_TRANSACTION_FEE,
//   ORDER_BY_DIRECT_MERCHANTS_COMMISSION,
//   ORDER_BY_PARTNERS_NUM_MERCHANTS,
//   ORDER_BY_PARTNERS_PROCESSING_VOLUME,
//   ORDER_BY_PARTNERS_TRANSACTION_FEE,
//   ORDER_BY_PARTNERS_COMMISSION
// } from './reducer';
// import { handleLoadReferralCryptoWallets } from '../../Account/CryptoWallets/sagas';
// import { calculatePagination } from '../../../utilities/misc';
// import {
//   loadCommissionSummary,
//   loadDirectMerchantCommission,
//   loadPartnerCommission,
//   handleLoadUpdateCommission
// } from '../../../utilities/commissionPayouts/sagas/show';

import { takeLatest, put } from 'redux-saga/effects';
import { getRequest, handleSagaError } from '../../../utilities/requests';

import {
  LOAD_SHOW,
  loadReferredPartnersShowFailure,
  setReferredPartnersShow
} from './reducer';

// function handleLoadSummary(action) {
//   const path = 'pending_commission_payouts';
//   return loadCommissionSummary(action, path);
// }

// function handleLoadDirectMerchantCommission(action) {
//   const url = `/pending_commission_payouts/${action.params.id}/commissions`;
//   return loadDirectMerchantCommission(action, url);
// }

// function handleLoadPartnerCommission(action) {
//   const url = `/pending_commission_payouts/${action.params.id}/referral_details`;
//   return loadPartnerCommission(action, url);
// }

// function* handleLoadCommissionDueShow(action) {
//   try {
//     const [summaryResponse, directMerchantsResponse] = yield all([
//       handleLoadSummary(action),
//       handleLoadDirectMerchantCommission(action),
//       handleLoadReferralCryptoWallets()
//     ]);

//     yield put(
//       setCommissionShow(
//         summaryResponse.data,
//         directMerchantsResponse.data,
//         action.params.id
//       )
//     );
//   } catch (error) {
//     yield put(commissionDueShowFailed());
//   }
// }

// function* handleLoadCommissionDueUpdateShow(action) {
//   try {
//     const id = yield select(
//       state => state.commissionPayouts.commissionDue.show.selectedIso
//     );
//     const options = {
//       slice: {
//         commissionType: 'commissionDue',
//         id
//       },
//       method: {
//         calculatePagination,
//         setPaginatorTotal,
//         setCommissionDirectMerchants,
//         setCommissionPartners,
//         handleLoadDirectMerchantCommission,
//         handleLoadPartnerCommission
//       }
//     };
//     yield handleLoadUpdateCommission(action, options);
//   } catch (error) {
//     yield put(commissionDueUpdateShowFailed());
//   }
// }

function* handleLoadReferredPartnersShow(action) {
  try {
    const url = `/referral_details/${action.params.id}`;
    const response = yield getRequest(url);
    // if (config.include_stats) {
    //   yield put(setReferredPartnerStatistics(response.data));
    // }
    // yield calculatePagination(
    //   response.data.total_referral_details,
    //   perPage,
    //   setPaginatorTotal
    // );
    yield put(setReferredPartnersShow(response.data));
    // yield handleLoadStatisticsSummary();
  } catch (error) {
    yield handleSagaError(
      error,
      'There was an error loading referred partner history.',
      loadReferredPartnersShowFailure
    );
  }
}

export function* loadReferredPartnersShowSaga() {
  yield takeLatest(
    [
      LOAD_SHOW
      // CHANGE_PAGINATOR_PAGE,
      // SET_PER_PAGE_FILTER,
      // ORDER_BY_PROCESSING_VOLUME,
      // ORDER_BY_TRANSACTION_FEE,
      // ORDER_BY_NUM_MERCHANTS,
      // SET_SEARCH_FILTER,
      // SET_CALENDAR_SAGA,
      // CLEAR_CALENDAR_FILTER
    ],
    handleLoadReferredPartnersShow
  );
}
